(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/custom-collection"],{

/***/ "./src/assets/js/custom-collection.js":
/*!********************************************!*\
  !*** ./src/assets/js/custom-collection.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CollectionCustomDropdown = /*#__PURE__*/function (_HTMLElement) {
  function CollectionCustomDropdown() {
    var _this;
    _classCallCheck(this, CollectionCustomDropdown);
    _this = _callSuper(this, CollectionCustomDropdown);
    _this.dropdownContent = null;
    _this.titleTrigger = null;
    _this.datatype = null;
    return _this;
  }
  _inherits(CollectionCustomDropdown, _HTMLElement);
  return _createClass(CollectionCustomDropdown, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.dropdownContent = this.querySelector('.collection-custom-dropdown__content');
      this.titleTrigger = this.querySelector('.collection-custom-dropdown__title');
      this.datatype = this.getAttribute('data-dropdowntype');
      this.titleTrigger.addEventListener('click', function () {
        _this2.toggleDropdown();
        _this2.closeOtherDropdowns();
      });
      if (this.datatype === 'filter') {
        this.initFilters();
      } else {
        this.initCollectionFilters();
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      this.classList.toggle('collection-custom-dropdown__content--active');
    }
  }, {
    key: "closeOtherDropdowns",
    value: function closeOtherDropdowns() {
      var _this3 = this;
      document.querySelectorAll('collection-custom-dropdown').forEach(function (dropdown) {
        if (dropdown !== _this3) {
          dropdown.classList.remove('collection-custom-dropdown__content--active');
        }
      });
    }

    // collection url based filters
  }, {
    key: "initCollectionFilters",
    value: function initCollectionFilters() {
      var _this4 = this;
      var radioButtons = this.dropdownContent.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(function (radio) {
        radio.addEventListener('change', _this4.handleCollectionFilterChange.bind(_this4));
      });
    }
  }, {
    key: "handleCollectionFilterChange",
    value: function handleCollectionFilterChange(event) {
      var url = new URL(event.target.value, window.location.origin);
      this.combineFilterParams(url); // Combine with other filters

      var renderSelectors = this.getAttribute('data-renderselectors');
      if (renderSelectors) {
        this.fetchAndUpdateAdditionalSections(url.toString(), renderSelectors);
      }
      this.fetchAndUpdateFilters(url.toString()); // Fetch and update the filter dropdown
    }
  }, {
    key: "combineFilterParams",
    value: function combineFilterParams(url) {
      var searchParams = new URLSearchParams(url.search);

      // Retain existing filter parameters (checkboxes)
      var existingParams = new URLSearchParams(window.location.search);
      existingParams.forEach(function (value, key) {
        if (key.startsWith('filter.')) {
          searchParams.set(key, value);
        }
      });
      url.search = searchParams.toString();
      this.updateUrl(url.toString());
      this.fetchAndUpdateContent(url.toString());
    }
  }, {
    key: "fetchAndUpdateFilters",
    value: function fetchAndUpdateFilters(url) {
      var _this5 = this;
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var filterDropdown = document.querySelector('collection-custom-dropdown[data-dropdowntype="filter"]');
        if (filterDropdown) {
          var newFilterDropdownHTML = doc.querySelector('collection-custom-dropdown[data-dropdowntype="filter"]').innerHTML;
          filterDropdown.innerHTML = newFilterDropdownHTML;

          // Reinitialize the dropdown to reattach event listeners
          filterDropdown.init();
        }
        _this5.updateUrlWithCheckedFilters();
      })["catch"](function (error) {
        return console.error('Error:', error);
      });
    }
  }, {
    key: "reInitializeFilterDropdown",
    value: function reInitializeFilterDropdown(filterDropdown) {
      // Initialize the filters again
      filterDropdown.initFilters();

      // Optionally, re-add any other functionalities or event listeners here
    }
  }, {
    key: "updateUrlWithCheckedFilters",
    value: function updateUrlWithCheckedFilters() {
      var searchParams = new URLSearchParams(window.location.search);
      // Remove unchecked filter parameters
      Array.from(searchParams.keys()).forEach(function (key) {
        if (key.startsWith('filter.') && !document.querySelector("input[name=\"".concat(key, "\"]:checked"))) {
          searchParams["delete"](key);
        }
      });

      // Update the URL without reloading the page
      var newUrl = "".concat(window.location.pathname, "?").concat(searchParams.toString());
      window.history.pushState({
        path: newUrl
      }, '', newUrl);
    }
  }, {
    key: "syncWithOtherFilters",
    value: function syncWithOtherFilters(url) {
      var searchParams = new URLSearchParams(window.location.search);

      // Append new filter parameters from other filters
      document.querySelectorAll('.collection-custom-dropdown__content-item input[type="checkbox"]:checked').forEach(function (checkbox) {
        searchParams.append(checkbox.name, checkbox.value);
      });
      var newUrl = new URL(url, window.location.origin);
      newUrl.search = searchParams.toString();
      this.updateUrl(newUrl.toString());
      this.fetchAndUpdateContent(newUrl.toString());
    }
  }, {
    key: "updateUrl",
    value: function updateUrl(newUrl) {
      window.history.pushState({
        path: newUrl
      }, '', newUrl);
    }
  }, {
    key: "fetchAndUpdateAdditionalSections",
    value: function fetchAndUpdateAdditionalSections(url, selectors) {
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        selectors.split(',').forEach(function (selector) {
          var newSectionContent = doc.querySelector(selector).innerHTML;
          var currentSection = document.querySelector(selector);
          if (currentSection) {
            currentSection.innerHTML = newSectionContent;
          }
          document.querySelectorAll('.image-element').forEach(function (el) {
            el.style.opacity = 1;
          });
        });
      })["catch"](function (error) {
        return console.error('Error:', error);
      });
    }

    // default filters
  }, {
    key: "initFilters",
    value: function initFilters() {
      var _this6 = this;
      var checkboxes = this.dropdownContent.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', _this6.handleFilterChange.bind(_this6));
      });
    }
  }, {
    key: "removeActiveCheckboxes",
    value: function removeActiveCheckboxes(event) {
      var activeCheckboxes = this.querySelectorAll('input[type="checkbox"]:checked');
      activeCheckboxes.forEach(function (checkbox) {
        if (checkbox != event.target) {
          checkbox.checked = false;
        }
      });
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(event) {
      this.removeActiveCheckboxes(event);
      var searchParams = new URLSearchParams(window.location.search);
      // Clear existing filter parameters
      Array.from(searchParams.keys()).forEach(function (key) {
        if (key.startsWith('filter.')) {
          searchParams["delete"](key);
        }
      });

      // Append or replace new filter parameters
      document.querySelectorAll('.collection-custom-dropdown__content-item input[type="checkbox"]:checked').forEach(function (checkbox) {
        if (searchParams.has(checkbox.name)) {
          searchParams.set(checkbox.name, checkbox.value); // Replace existing value
        } else {
          searchParams.append(checkbox.name, checkbox.value); // Append new value
        }
      });

      // Update the URL without reloading the page
      var newUrl = "".concat(window.location.pathname, "?").concat(searchParams.toString());
      window.history.pushState({
        path: newUrl
      }, '', newUrl);
      this.fetchAndUpdateContent(newUrl);
      this.toggleDropdown();
    }
  }, {
    key: "fetchAndUpdateContent",
    value: function fetchAndUpdateContent(url) {
      document.body.classList.add('loading');
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#CollectionAjaxContent').innerHTML;
        document.getElementById('CollectionAjaxContent').innerHTML = newContent;
        new theme.QuickAdd(document.getElementById('CollectionAjaxContent'));
        new theme.QuickShop(document.getElementById('CollectionAjaxContent'));
        document.querySelectorAll('.image-element').forEach(function (el) {
          el.style.opacity = 1;
        });
      })["catch"](function (error) {
        return console.error('Error:', error);
      })["finally"](function () {
        document.body.classList.remove('loading');
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('collection-custom-dropdown')) {
  customElements.define('collection-custom-dropdown', CollectionCustomDropdown);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/custom-collection.js"));
/******/ }
]);